<template>
  <div class="modal fade !p-0" id="uniqueModalDiscard" ref="discardModal" tabindex="-1" aria-labelledby="discardModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered max-w-[500px]">
      <div class="modal-content !rounded-[10px] border-0 shadow-lg font-poppins mobile:mx-[15px] laptop:m-0 ">
        <div class="modal-body select-none discard-wrap !p-2.5 !pb-4">
          <div class="relative rounded-[10px] overflow-hidden h-[80px] bg-customBlue-100">
            <button type="button" @click="hide"
              class="absolute top-3 right-[10px] w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
              aria-label="Close">
              <img src="../../assets/images/white-cross-icon.svg" alt="Cross Icon" class="w-[30px] h-[30px] object-contain">
            </button>
            <h3
                class="absolute top-0 left-0 w-full h-full flex items-center justify-center m-0 font-roboto text-center text-[20px] px-[30px] lg:px-[40px] text-white">
                {{ title }}
              </h3>
          </div>
          <div>
            <div v-if="image != null"
              class="my-4 p-3 w-[80px] h-[80px] rounded-full mx-auto shadow-[0px_0px_10px_-1px_#ccc]">
              <img :src="require(`@/assets/images/${image}`)" class="w-full h-full">
            </div>
            <p v-if="text.length <= 0" class="my-[15px] font-roboto text-center text-[16px] laptop:text-[18px] text-[#333333]">
              {{ text }}
            </p>
            <div v-else v-html="text" class="my-[15px] font-roboto text-center text-[16px] laptop:text-[18px] text-[#333333]">
            </div>
            <div class="flex flex-row justify-center gap-3">
              <button @click="confirm"
                class="font-roboto text-[14px] py-2 px-[32px] rounded-lg CustomYellowBtn font-semibold">
                {{ buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/plugins/EventBus";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from 'bootstrap';

export default {
  data() {
    return {
      modal: null,
      title: "",
      text: "",
      image: null,
      buttonText: 'Continue',
      onConfirm: {},
    };
  },

  mounted() {
    EventBus.on("show", (params) => {
      this.show(params);
    });
  },

  methods: {
    hide() {
      if (this.modal) {
        this.modal.hide();
      }
      enableScroll();
    },
    confirm() {
      if (typeof this.onConfirm === "function") {
        this.onConfirm();
      }
      this.hide();
    },
    show(params) {
      this.title = params.title;
      this.text = params.text ?? "";
      this.image = params.image;
      this.onConfirm = params.onConfirm;
      this.buttonText = params.buttonText ?? 'Continue'

      this.$nextTick(() => {
        const el = this.$refs.discardModal;
        if (el) {
          if (!this.modal) {
            this.modal = Modal.getOrCreateInstance(el);
          }
          if (this.modal) {
            this.modal.show();
            disableScroll();
          }
        }
      });
    },
  },
};
</script>